import React, { useEffect, useRef, useState } from "react";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import { Toast } from "primereact/toast";
import oilProductionService from "../../services/oilProduction/oilProductionservice";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";

const OilProductionLog1: React.FC = () => {
  const now = new Date();
  const twoHourLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);

  const [date, setDate] = useState<Date | null>(new Date());
  const [startTime, setStartTime] = useState<Date>(new Date());
  const [endTime, setEndTime] = useState<Date>(new Date());
  const [plant, setPlant] = useState<string>("");
  const [manufactureId, setManufactureId] = useState<number | null>(null);
  const [oilseed, setOilseed] = useState<number | null>(null);
  const [oilseeds, setOilseeds] = useState<{ label: string; value: number }[]>(
    []
  );
  const [vendors, setVendors] = useState<{ label: string; value: number }[]>(
    []
  );

  const [selectedVendor, setSelectedVendor] = useState<number | null>(null);
  const [vendorInvoices, setVendorInvoices] = useState<any[]>([]);
  const [invoiceOptions, setInvoiceOptions] = useState<
    { label: string; value: string; quantityLeft: number }[]
  >([]);
  const [operators, setOperators] = useState<
    { label: string; value: number }[]
  >([]);
  const [selectedOperator1, setSelectedOperator1] = useState<number | null>(
    null
  );
  const [selectedOperator2, setSelectedOperator2] = useState<number | null>(
    null
  );
  const [bulls, setBulls] = useState<{ label: string; value: number }[]>([]);
  const [selectedBull1, setSelectedBull1] = useState<number | null>(null);
  const [selectedBull2, setSelectedBull2] = useState<number | null>(null);
  const [oilseedWeight, setOilseedWeight] = useState<number | null>(null);
  const [moistureContent, setMoistureContent] = useState<number | null>(null);
  const [emptyContainerWeight, setEmptyContainerWeight] = useState<
    number | null
  >(null);
  const [gaanaNumber, setGaanaNumber] = useState<number | null>(null);
  const [hoveredField, setHoveredField] = useState<string | null>(null);
  const [gaanaOptions, setGaanaOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
  const toast = useRef<Toast>(null);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  const navigate = useNavigate();
  const breadcrumbItems = [
    { label: "Oil Mill Operations", url: "" },
    { label: "Stage 1 : Raw Material Intake", url: "" },
  ];
  const home = { icon: "pi pi-home", url: "/" };

  useEffect(() => {
    const fetchPlantDetails = async () => {
      try {
        const response = await oilProductionService.GetMUPlantName1();
        if (response && response.length > 0) {
          const firstPlant = response[0];
          setPlant(firstPlant.address2);
          setManufactureId(firstPlant.posID);

          const membersResponse =
            await oilProductionService.getBullsAndOperators(firstPlant.posID);
          if (membersResponse) {
            const operatorList = membersResponse.operators.map((op: any) => ({
              label: op.name,
              value: op.id,
            }));
            const bullList = membersResponse.bulls.map((b: any) => ({
              label: b.name,
              value: b.id,
            }));
            const gaanaList = (membersResponse.gaanaDetails || []).map(
              (g: any) => ({
                label: g.gaanaNumber,
                value: g.id,
              })
            );

            setOperators(operatorList);
            setBulls(bullList);
            setGaanaOptions(gaanaList);
          }
        }
      } catch (error) {
        console.error("Error fetching plant details:", error);
      }
    };

    fetchPlantDetails();
  }, []);

  useEffect(() => {
    const loadOilSeed = async () => {
      if (manufactureId === null) return;
      try {
        const response = await oilProductionService.getOilSeedNames(
          manufactureId
        );
        const formatted = response.map((item: any) => ({
          label: `${item.rawMaterialName} (${item.availableQty} kg)`,
          value: item.rawMaterialID,
        }));
        setOilseeds(formatted);
      } catch (error) {
        console.error("Failed to load oilseed types:", error);
      }
    };

    loadOilSeed();
  }, [manufactureId]);

  const validateForm = (): boolean => {
    if (!date) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select a date",
        life: 3000,
      });
      return false;
    }

    if (!gaanaNumber) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Select Gaana Number",
        life: 3000,
      });
      return false;
    }
    if (!oilseed) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select an oilseed",
        life: 3000,
      });
      return false;
    }
    if (!selectedVendor) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select a vendor",
        life: 3000,
      });
      return false;
    }
    if (!selectedInvoice) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select an invoice",
        life: 3000,
      });
      return false;
    }

    if (!oilseedWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Oil Seed Weight",
        life: 3000,
      });
      return false;
    }

    if (
      selectedInvoice?.quantityLeft &&
      oilseedWeight > selectedInvoice.quantityLeft
    ) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: `Entered weight exceeds available quantity (${selectedInvoice.quantityLeft} kg)`,
        life: 3000,
      });
      return false;
    }

if (moistureContent === null || moistureContent === undefined) {
  toast.current?.show({
    severity: "warn",
    summary: "Validation",
    detail: "Please Enter Moisture Content",
    life: 3000,
  });
  return false;
}

// Check if out of range
if (moistureContent <= 1 || moistureContent > 10) {
  toast.current?.show({
    severity: "warn",
    summary: "Validation",
    detail: "Moisture Content must be between  1  and 10",
    life: 3000,
  });
  setMoistureContent(null); // clear invalid value
  return false;
}


    if (!emptyContainerWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Empty Container Weight",
        life: 3000,
      });
      return false;
    }

    return true;
  };

  const showMessage = (
    summary: string,
    detail: string,
    severity: "success" | "error" | "warn" | "info"
  ) => {
    toast.current?.show({
      severity,
      summary,
      detail,
      life: 3000,
    });
  };


  const handleSubmit = async() => {
    const isValid = validateForm();
    if (!isValid) return;
    const payload = {
    rawMaterialPurchaseID: selectedInvoice?.value,
    posID: manufactureId,
    submittedDate: date!.toISOString().split("T")[0],
    gaanaID: gaanaNumber ?? null,
    oilSeedID: oilseed,
    oilSeedWeight: oilseedWeight,
    moistureContent: moistureContent,
    emptyContainerWeightKG: emptyContainerWeight,
  };

    try {
      await oilProductionService.addOilIntakeLog1(payload);
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Oil Intake Log saved successfully",
        life: 3000,
      });

      setConfirmVisible(false);

      navigate("/oildatatable1");

      setDate(new Date());
      setStartTime(new Date());
      setEndTime(new Date());
      setOilseed(null);
      setSelectedVendor(null);
      setSelectedInvoice(null);
      setOilseedWeight(null);
      setMoistureContent(null);
      setEmptyContainerWeight(null);
      setGaanaNumber(null);
      setSelectedOperator1(null);
      setSelectedOperator2(null);
      setSelectedBull1(null);
      setSelectedBull2(null);
      setVendors([]);
      setInvoiceOptions([]);
      setVendorInvoices([]);
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to save oil intake log",
        life: 5000,
      });
    }
  };

  const fieldHoverStyle = (fieldName: string) => ({
    border:
      hoveredField === fieldName ? "2px solid #6366F1" : "1px solid #ced4da",

    boxShadow:
      hoveredField === fieldName ? "0 0 6px rgba(99, 102, 241, 0.3)" : "none",
    transition: "all 0.2s ease-in-out",
    width: "100%",
    minHeight: "40px",
  });

  return (
    <>
      <Toast ref={toast} position="top-right" />
      <div>
        <div className="flex justify-between items-end flex-wrap gap-4 ">
          {/* Left side: Stage 1 heading */}
          <div>
            <h5
              className="border-round order-top-color p-2 m-0 mb-1"
              style={{ width: "fit-content" }}
            >
              Stage 1: Raw Material Intake
            </h5>
            <BreadCrumb
              model={breadcrumbItems}
              home={home}
              className="  bg-transparent px-0 py-0 text-sm  text-gray-600"
              style={{
                border: "none",
                boxShadow: "none",
                background: "transparent",
                marginLeft: "5px",
              }}
            />
          </div>

          {/* Right side: Date & Manufacturing Unit */}
          <div className="flex gap-8" style={{ paddingLeft: "199px" }}>
            <div className="field">
              <label>Date</label>
              <Calendar value={new Date()} disabled dateFormat="dd-mm-yy" />
            </div>
            <div className="flex gap-8">
              <div className="field">
                <label>Manufacturing Unit</label>
                <InputText value={plant} disabled />
              </div>
            </div>
          </div>
        </div>

        <div className="p-card p-4 shadow-lg rounded-lg bg-white mt-2">
          <div className="grid">
            <div className="col-12 mt-1">
              <div className="grid">
                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Gaana Number<span className="required">*</span>
                  </label>

                  <Dropdown
                    value={gaanaNumber}
                    options={gaanaOptions}
                    onChange={(e) => setGaanaNumber(e.value)}
                    placeholder="Select Gaana Number"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Oilseed Name<span className="required">*</span>
                  </label>
                  <Dropdown
                    value={oilseed}
                    options={oilseeds}
                    onChange={async (e) => {
                      const selectedOilseedId = e.value;
                      setOilseed(selectedOilseedId);

                      try {
                        const response =
                          await oilProductionService.getVendorsByOilseed(
                            selectedOilseedId,
                            manufactureId!
                          );
                        setVendorInvoices(response);

                        const formatted = response.map((vendor: any) => ({
                          label: vendor.firmInfo,
                          value: vendor.vendorID,
                        }));
                        setVendors(formatted);
                        setSelectedVendor(null);
                        setInvoiceOptions([]);
                        setSelectedInvoice(null);
                      } catch (err) {
                        console.error("Error fetching vendors:", err);
                      }
                    }}
                    placeholder="Select Oilseed Name"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Vendor Name<span className="required">*</span>
                  </label>
                  <Dropdown
                    value={selectedVendor}
                    options={vendors}
                    onChange={(e) => {
                      const selectedVendorId = e.value;
                      setSelectedVendor(selectedVendorId);

                      const vendor = vendorInvoices.find(
                        (v) => v.vendorID === selectedVendorId
                      );
                      if (vendor && vendor.invoices) {
                        const formattedInvoices = vendor.invoices.map(
                          (inv: any) => ({
                            label: `${inv.invoiceID} - ${inv.quantityLeft} kg`,
                            value: inv.id,
                            quantityLeft: inv.quantityLeft,
                          })
                        );
                        setInvoiceOptions(formattedInvoices);
                        setSelectedInvoice(null);
                      }
                    }}
                    placeholder="Select Vendor Name"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Vendor Invoice Number<span className="required">*</span>
                  </label>
                  <Dropdown
                    value={selectedInvoice?.value || null}
                    options={invoiceOptions}
                    onChange={(e) => {
                      const selected = invoiceOptions.find(
                        (inv) => inv.value === e.value
                      );
                      setSelectedInvoice(selected || null);
                    }}
                    optionLabel="label"
                    placeholder="Select Vendor Invoice Number"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Oilseed Weight (kg)<span className="required">*</span>
                  </label>
                  <InputNumber
                    value={oilseedWeight}
                    onValueChange={(e) => {
                      const enteredWeight = e.value ?? 0;
                      console.log("Entered Weight:", enteredWeight);
                      console.log("Selected Invoice:", selectedInvoice);
                      console.log(
                        "Selected Invoice Quantity Left:",
                        selectedInvoice?.quantityLeft
                      );

                      if (
                        selectedInvoice?.quantityLeft &&
                        enteredWeight > selectedInvoice.quantityLeft
                      ) {
                        showMessage(
                          "Validation Error",
                          `Weight cannot exceed ${selectedInvoice.quantityLeft} kg`,
                          "error"
                        );
                        return; 
                      }

                      setOilseedWeight(enteredWeight);
                    }}
                    placeholder="Enter weight"
                    mode="decimal"
                    minFractionDigits={2}
                    step={0.01}
                    useGrouping={false}
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>

 <div className="field col-12 md:col-3">
  <label className="label-semi-bold">
    Moisture Content (%)<span className="required">*</span>
  </label>
  <InputNumber
    value={moistureContent}
    onChange={(e) => {
      const value = e.value ?? null;

      // Only accept values 7 to 10
      if (value !== null && (value < 7 || value > 10)) {
        setMoistureContent(null);

        toast.current?.show({
          severity: "warn",
          summary: "Validation Error",
          detail: "Moisture content must be between 7 and 10",
          life: 3000,
        });
           setMoistureContent(0);
      } else {
        setMoistureContent(value);
      }
    }}
    placeholder="Enter Moisture content"
    mode="decimal"
    step={0.01}
    minFractionDigits={2}
    useGrouping={false}
    className="w-full"
    style={fieldHoverStyle("description")}
  />
</div>




                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Empty Container Weight (kg)
                    <span className="required">*</span>
                  </label>
                  <InputNumber
                    value={emptyContainerWeight}
                    onValueChange={(e) =>
                      setEmptyContainerWeight(e.value ?? null)
                    }
                    placeholder="Enter Empty Container Weight"
                    mode="decimal"
                    minFractionDigits={2}
                    step={0.01}
                    useGrouping={false}
                    className="w-full"
                    style={fieldHoverStyle("description")}
                    maxLength={8}
                  />
                </div>
              </div>
            </div>
            <div className="field col-12 text-center mt-4">
              <Button
                label="Save"
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OilProductionLog1;
